/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import FormGenerator from '../../../../utils/helpers/FormGenerator'
import Button from 'react-bootstrap/Button'
import ProgressBar from 'react-bootstrap/ProgressBar'
import MasterServices from '../../../../services/master'
import UserServices from '../../../../services/user'
import Table from 'react-bootstrap/Table'

const Page = () => {
  const [formValue, setFormValue] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [reportData, setReportData] = useState([])
  const [filter, setFilter] = useState({
    province_id: [],
  })
  const [inputs, setInputs] = useState([
    {
      name: 'province_id',
      label: 'Provinsi',
      type: 'select2',
      validation: {},
      col: 4,
      options: [],
      getItemValue: 'provinces_name',
      getItemValueId: 'provinces_id',
      additional: '',
      isMulti: true,
    },
  ])

  useEffect(() => {
    fetchProvice()
  }, [])

  useEffect(() => {
    fetchReportALumni(filter)
  }, [filter])

  const fetchProvice = async (q = '') => {
    setLoading(true)
    await MasterServices.getProvince({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[0].options = data
        setInputs(inputs)
        setLoading(false)
      })
      .catch((err) => {
      })
  }

  const fetchReportALumni = async (filter: any) => {
    setLoading(true)
    setDisabled(true)
    await UserServices.reportAlumni(filter)
      .then((response) => {
        setReportData(response.data)
        setLoading(false)
        setDisabled(false)
      })
      .catch((err) => {
      })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onSelect = (input: any, row: any) => {
    switch (input) {
      case 'province_id':
        fetchProvice(row)
        break
    }
  }

  const handleSubmit = () => {
    let provinces = formValue?.province_id?.map((item: any) => item.provinces_id) ?? ['all']

    setFilter({
      province_id: provinces,
    })
  }

  const handleExportPdf = async (filter: any) => {
    setDisabled(true)
    try {
      const response: any = await UserServices.pdfReportAlumni({
        province_id: filter?.province_id?.length > 0 ? filter?.province_id : ['all'],
      })
      const {file, name} = response.data
      var a = document.createElement('a')
      a.href = file
      a.download = name
      document.body.appendChild(a)
      a.click()
      a.remove()
      setDisabled(false)
    } catch (error) {
      setDisabled(false)
    }
  }

  const handleExportExcel = async (filter: any) => {
    setDisabled(true)
    try {
      const response: any = await UserServices.excelReportAlumni({
        province_id: filter?.province_id?.length > 0 ? filter?.province_id : ['all'],
      })
      const {file, name} = response.data
      var a = document.createElement('a')
      a.href = file
      a.download = name
      document.body.appendChild(a)
      a.click()
      a.remove()
      setDisabled(false)
    } catch (error) {
      setDisabled(false)
    }
  }

  return (
    <div className='row d-grid gap-10'>
      <div className='col-md-12'>
        <div className='card-custom'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='row'>
                {FormGenerator(inputs, formValue, onChange, onSelect, loading)}
              </div>
            </div>
            <div className='col-md-12'>
              <div className='row'>
                <div className='col-md-6'>
                  <Button
                    className='btn btn-sm btn-primary'
                    disabled={disabled}
                    onClick={() => handleSubmit()}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-md-12'>
        <div className='card-custom'>
          <div className='col-md-9'>
            <Button
              className='btn btn-sm me-1'
              type='button'
              disabled={disabled}
              onClick={() => handleExportPdf(filter)}
            >
              Pdf
            </Button>
            <Button
              className='btn btn-success btn-sm me-1'
              type='button'
              disabled={disabled}
              onClick={() => handleExportExcel(filter)}
            >
              Excel
            </Button>
          </div>
          <Table responsive className='table-striped align-middle'>
            <thead>
              <tr>
                <th>Jenis</th>
                <th className='text-center'>Jumlah</th>
                <th className='text-center'>Grafik</th>
              </tr>
            </thead>
            <tbody>
              {reportData ? (
                reportData?.map((item: any) => {
                  return (
                    <tr>
                      <td>{item?.provinces_name}</td>
                      <td className='text-center'>{item?.count}</td>
                      <td>
                        <ProgressBar variant='info' now={item?.count} />
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={3} className='text-center'>
                    Tidak ada data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

const list = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Alumni - Provinsi
      </PageTitle>
      <Page />
    </>
  )
}

export default list
